import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';

import * as selectors from '../redux/selectors';
import { getCheckVerification } from '../redux/verification/actions';
import * as checkVerifyStatus from '../redux/verification/status';
import { flashMessage } from '../redux/flash/actions';

import { loopFunc } from '../utils/time';

import ListTable from '../components/ListTable';
import CheckVerifyListItems from '../components/CheckVerifyListItems';
import InfoPopUp from '../components/InfoPopUp';

import refresh from '../assets/icons/ico_refresh.png';

import * as data from '../const/checkVeriyLists';

class CheckVerifications extends Component {
  static contextTypes = {
    checkVerifications: PropTypes.array,
    store: PropTypes.object,
  }

  static mapStateToProps = state => ({
    checkVerifications: selectors.getCheckVerifyList(state),
    loading: selectors.getCheckVerifyLoading(state),
  })

  constructor(props) {
    super(props);
    this.state = {
      search: '',
      items: [],
      currentSelect: data.DATA_TYPES[0],
      header: data.HEADER,
      pageOfItems: [],
      checkVerifications: [],
    };
  }

  async componentDidMount() {
    await loopFunc(this.getCheckVerification);
  }

  handleChange = async (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    }, () => {
      this.filterData();
    });
  }

  handleSelect = async (currentSelect) => {
    this.setState({
      currentSelect
    }, () => {
      this.filterData();
    });
  }

  filterData = () => {
    const { search, currentSelect } = this.state;
    const items = this.state.items.filter(item => {
      const value = currentSelect.convert(item[currentSelect.eventKey]);

      if (currentSelect.eventKey !== 'all') {
        if (value) {
          return value.toLowerCase().search(search.toLowerCase()) !== -1;
        }
        return false;
      }
      const filterTypes = data.DATA_TYPES.filter(d => d.eventKey !== 'all');
      return filterTypes.some(filter => {
        const itemValue = filter.convert(item[filter.eventKey]);
        if (itemValue) {
          return itemValue.toLowerCase().search(search.toLowerCase()) !== -1;
        }
        return false;
      });
    });
    this.setState({ checkVerifications: items });
  }

   getCheckVerification = async (month) => {
    const { store } = this.context;
    const body = { month };
    const res = await store.dispatch(getCheckVerification(body));
    if (res === checkVerifyStatus.CHECKVERIFICATION_STATUS_OK) {
      const items = this.state.items.concat(this.props.checkVerifications);
      const checkVerifications = items;
      await this.setState({items, checkVerifications});
      return;
    }
    store.dispatch(flashMessage('Error getting the list. Please refresh to try again.', 'error'));
  }

  updateList = async () => {
    await this.setState({
      checkVerifications: [],
      items: [],
    }, () => { loopFunc(this.getCheckVerification) });
  }

  render() {
    return(
      <div>
        <h3 className="header">
        { this.state.checkVerifications ?
          <code>{this.state.checkVerifications.length}</code>
          : null
        }
        &nbsp;
        Check with Issue / Incomplete
        <button onClick={this.updateList} className="iconBtn">
          <img src={refresh} alt="refresh" />
        </button>
        </h3>
        <p className="header">
          NOTE: Usually happens due to network failure, mismatch user info from CCRIS, mismatch IC info
        </p>
          <ListTable
            currentSelect={this.state.currentSelect}
            sortTitle={this.state.sortTitle}
            types={data.DATA_TYPES}
            sortTypes={data.SORT_DATA_TYPES}
            header={this.state.header}
            loading={this.props.loading}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
            renderHeader={(item, idx) => {
              switch (idx) {
                case 0 :
                  return <Col className="indexCol" key={idx}>{item.title}</Col>
                case 1 :
                  return <Col className="createdAt" key={idx}>{item.title}</Col>
                case 5 :
                  return (
                    <Col xs={2} className="centerCol" key={idx}>
                      {item.title}
                      <InfoPopUp>
                        <ol>
                          <li>Bad Request usually happens due to wrong data entered by the user (e.g name and ic mismatch), or it also because CTOS unable to process the credit check request. Rerun check would be the next course of action to take.</li>
                          <li>New means our system is yet to processed the user's credit check request</li>
                        </ol>
                      </InfoPopUp>
                    </Col>  
                  )
                default:
                  return <Col xs={2} key={idx}>{item.title}</Col>
              }
            }}
            renderContent={({ pageOfItems, reveal, onReveal }) => (
              <CheckVerifyListItems
                checkVerifications={pageOfItems}
                reveal={reveal}
                onReveal={onReveal}
              />
            )}
            items={this.state.checkVerifications}
          />
      </div>
    );
  }
}

export default connect(CheckVerifications.mapStateToProps)(CheckVerifications);



// WEBPACK FOOTER //
// ./src/containers/CheckVerifications.jsx